module.exports = __webpack_public_path__ + "static/curtain-lowres-1474e589a02a851436f085a5285e9fbd.mp4";